import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { color } from 'echarts';
import { ChartPie } from 'src/app/Interfaces/Admin/charts/SimpleCharPie.interface';

@Component({
    selector: 'app-simple-chart-pierc',
    templateUrl: './simple-chart-pierc.component.html',
    styleUrls: ['./simple-chart-pierc.component.scss', '../../../../Components/Styles/GlobalStyles.css'],
    standalone: false
})
export class SimpleChartPiercComponent implements OnInit, OnChanges {

  //+===================== INPUTS =====================+\\
  @Input() DataChartPie!: ChartPie;

  //+================== VARIABLES FOR CHART ==================+\\
  @ViewChild('chartPie', { static: true }) chartContainer!: ElementRef;

  private MyChart!: echarts.ECharts;

  ngOnInit(): void {
    echarts.use([
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      PieChart,
      CanvasRenderer,
      LabelLayout
    ]);

    this.MyChart = echarts.init(this.chartContainer.nativeElement);
    this.updateChart();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['DataChartPie'] && !changes['DataChartPie'].firstChange) {
      this.updateChart();
    }

  }

  //-================== LOAD CHART OPTIONS AND DATA ==================-\\
  private getChartOptions() {

    var option;

    option = {
      title: {
        text: this.DataChartPie.Title,
        left: 'center'
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        orient: 'horizontal',
        left: 'center',
        bottom: '0%'
      },
      color: ['#1CA5D6', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF', '#072834', '#0B3F52', '#0F5A75', '#147496', '#1785AD', '#188FBA', '#1B9DCC', '#1CA5D6', '#21AEEB', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF'],
      labelLine: {
        show: true
      },
      emphasis: {
        label: {
          show: true,
          fontSize: 11,
          fontWeight: 'bold'
        }
      },
      series: [
        {
          type: 'pie',
          radius: `${this.DataChartPie.percent}%`,
          label: {
            position: 'inner',
            fontSize: 11,
            color: '#fff'
          },
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 0
          },
          data: this.DataChartPie.Data,

        }
      ]
    };

    return option

  }

  private updateChart(): void {
    const options = this.getChartOptions();
    this.MyChart.resize();
    this.MyChart.setOption(options);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.MyChart) {
      this.MyChart.resize();
    }
  }
}